<template>
	<section id="coach" class="container coach">
		<div class="section-head">
			<span class="label">Head coach</span>
			<h2 class="cap section-title">Learn from a competitor</h2>
		</div>
		<article class="card coach-card">
			<img src="/img/pablo_pic.jpg" alt="Pablo Cerino sitting on the mats" class="photo" loading="lazy" />
			<div class="text">
				<h3 class="cap name">Pablo Cerino</h3>
				<span class="mono rank">4th degree black belt · training since 1993</span>
				<p>
					Pablo still competes at the biggest events. Brazilian, in Brussels since 2008, he teaches in
					Portuguese, French and English.
				</p>
			</div>
		</article>
	</section>
</template>

<style scoped>
.coach {
	padding-top: 80px;
	padding-bottom: 40px;
	display: flex;
	flex-direction: column;
	gap: 28px;
}

.coach-card {
	padding: 16px;
	display: flex;
	flex-wrap: wrap;
	gap: 32px;
	align-items: center;
}

.photo {
	flex: 0 1 300px;
	width: 300px;
	height: 380px;
	object-fit: cover;
	object-position: center 30%;
	border-radius: 12px;
	filter: grayscale(1);
}

.text {
	flex: 1 1 360px;
	padding: 8px;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.name {
	font-size: 44px;
	line-height: 1;
}

.rank {
	font-size: 13px;
	color: var(--mat-deep);
}

.text p {
	max-width: 560px;
	font-size: 17px;
	color: #3a3a3a;
}

@media (max-width: 768px) {
	.coach {
		padding-top: 48px;
		padding-bottom: 0;
		gap: 16px;
	}

	.coach-card {
		padding: 12px;
		gap: 14px;
	}

	.photo {
		flex-basis: 100%;
		width: 100%;
		height: 360px;
	}

	.text {
		flex-basis: 100%;
		padding: 0 6px 6px;
		gap: 6px;
	}

	.name {
		font-size: 34px;
	}

	.rank {
		font-size: 12px;
	}

	.text p {
		font-size: 15px;
	}
}
</style>
